import { AccionModal } from './../../shared/models/modal-select.model';
import { FormGroup, FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ColumnsTableModalSelect } from '@app/shared';
import { Logger } from '@app/core';
import { ToastrService } from 'ngx-toastr';

const log = new Logger('SelectorModalComponent');

@Component({
  selector: 'iw-selector-modal',
  templateUrl: './selector-modal.component.html',
  styleUrls: ['./selector-modal.component.scss']
})
export class SelectorModalComponent implements OnInit {

  form: FormGroup = new FormGroup({
    exampleModalSelect: new FormControl()
  });

  municipalities = [
    {
      id: 1,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Medellin'
    },
    {
      id: 2,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Bello'
    },
    {
      id: 3,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Itagui'
    },
    {
      id: 4,
      country: 'Colombia',
      department: 'Cundinamarca',
      municipalities: 'Zipaquirá'
    },
    {
      id: 5,
      country: 'Colombia',
      department: 'Cundinamarca',
      municipalities: 'Soacha'
    },
    {
      id: 6,
      country: 'Colombia',
      department: 'Cundinamarca',
      municipalities: 'Ubate'
    },
    {
      id: 7,
      country: 'Colombia',
      department: 'Atlantico',
      municipalities: 'Barranquilla'
    },
    {
      id: 8,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Abejorral'
    },
    {
      id: 9,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Amagá'
    },
    {
      id: 10,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Amalfi'
    },
    {
      id: 11,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Caldas'
    },
  ];

  columnsSelect: Array<ColumnsTableModalSelect> = [
    {
      key: 'department',
      label: 'Departamento'
    },
    {
      key: 'municipalities',
      label: 'Municipio'
    },
  ];

  constructor(private toastr: ToastrService) { }

  ngOnInit() {
  }

  onSubmit(data: any) {
    console.log(data);
  }

  actionModalSelect(data: AccionModal) {
    log.debug(data.accion, data);
    switch (data.accion) {
      case 'actualizar':
        this.toastr.warning('Actualizar registro', 'Accion en la tabla');
        break;
      case 'eliminar':
        this.toastr.error('Eliminar registro', 'Accion en la tabla');
        break;
      default:
        this.toastr.success('Agregar registro', 'Accion en la tabla');
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/examples/selector-modal/selector-modal.component.ts